import { z } from 'zod';

// 基本情報変更フォームのバリデーションスキーマ
export const resetInformationSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('有効なメールアドレスを入力してください'),
  phoneNumber: z
    .string()
    .min(1, '電話番号は必須です')
    .regex(/^[0-9-+()\s]+$/, '有効な電話番号を入力してください')
    .min(10, '電話番号は10文字以上で入力してください')
    .max(15, '電話番号は15文字以内で入力してください'),
});
